import React, { useState, useEffect } from "react";
import Confetti from "react-confetti";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import emailjs from "emailjs-com";
import "../App.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Lottie from "react-lottie";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";

import * as incorrectAnimation from "../assets/incorrectAnimation.json";
import * as correctAnimation from "../assets/correctAnimation.json";
import * as coinAdded from "../assets/coinAdded.json";
import * as wallet from "../assets/wallet.json";
import * as secondAdded from "../assets/plusSeconds.json";
import { useMediaQuery } from "@mui/material";

import wordsArray from "../assets/words_so.json";
function GamePage() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const recipientEmail = "Biniam@goodppls.com";
  const handleFeedback = () => {
    const subject = encodeURIComponent("Feedback"); // Optionally, you can set a subject for the email
    const body = encodeURIComponent(
      "Vocaps,\n\nI would like to share the following feedback:\n\n"
    ); // Optionally, you can set a body for the email
    window.location.href = `mailto:${recipientEmail}?subject=${subject}&body=${body}`;
  };
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const englishAlphabet = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];

  const columnColors = [
    "#000000", // Default color
    "#DA300B", // Red
    "#DEB82A", // Gold
    "#00B050", // Green
    "#0000FF", // Blue
    "#8064A2", // UV (Ultra Violet)
    "#B7B7B7", // Opal
  ];
  const customColors = {
    C: "#DA300B",   // Red
    DH: "#DEB82A",  // Gold
    KH: "#00B050",  // Green
    Q: "#0000FF",   // Blue
    R: "#8064A2",   // UV
    X: "#B7B7B7",   // Opal
  };
  const [timeLeft, setTimeLeft] = useState(90);
  const [timeIsUp, setTimeIsUp] = useState(false);
  const commonWordsGroups = ["A", "B","D", "G", "H","S"];
  const [points, setPoints] = useState(500);
  const [draggedItem, setDraggedItem] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [gameLastQuestion, setGameLastQuestion] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [correctAnswer, setCorrectAnswer] = useState(false);
  const [showMissing, setShowMissing] = useState(false);
  const [showDefinition, setShowDefinition] = useState(false);
  const [currentDescription, setCurrentDescription] = useState("");
  const [currentHint1, setCurrentHint1] = useState("");
  const [currentHint2, setCurrentHint2] = useState("");
  const [currentHint3, setCurrentHint3] = useState("");
  const [selectedWord, setSelectedWord] = useState("");
  const currentWordObj = wordsArray[currentIndex];
  const [selectedLevel, setSelectedLevel] = useState("Beginner");
  const [selectedGameType, setSelectedGameType] = useState("FreePlay");
  const [answerDropped, setAnswerDropped] = useState(false);
  const [showCoinAnimation, setShowCoinAnimation] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showWordModal, setShowWordModal] = useState(false);
  const [showHintModal, setShowHintModal] = useState(false);
  const [showGameOverModal, setShowGameOverModal] = useState(false);
  const [email, setEmail] = useState("");
  const [clickedWord, setClickedWord] = useState("");
  const [showAnswer, setShowAnswer] = useState(false);
  const BIN_ID = "66d6c0cdad19ca34f89f4d54";
  const API_KEY =
    "$2a$10$v1S1l2pNRqqSQgWfq9tplOAW9Ocu9/0bONnlI5nsqxavJdscSm8ra";
  const BIN_VERSION = "latest"; // Or specify a version if needed
  const [codes, setCodes] = useState([]);
  const [randomCode, setRandomCode] = useState(null);
  const [correctAnswersCount, setCorrectAnswersCount] = useState(0);
  const [wrongAnswersCount, setWrongAnswersCount] = useState(0);

  const [showNotEnoughCoinsModal, setShowNotEnoughCoinsModal] = useState(false);
  const [visibleGroups, setVisibleGroups] = useState(commonWordsGroups);
  const [hideCharactersTimer, setHideCharactersTimer] = useState(null);
  const [consecutiveCorrect, setConsecutiveCorrect] = useState(0);
  const [showSecondsAnimation, setShowSecondsAnimation] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);
  // Countdown effect
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      return () => clearInterval(timer);
    } else {
      if (selectedGameType === "TimedPlay") {
        setShowGameOverModal(true);
        setTimeIsUp(true);
      }
    }
  }, [timeLeft]);

  useEffect(() => {
    if (correctAnswer) {
      setShowCoinAnimation(true);
      setTimeout(() => {
        setShowCoinAnimation(false);
      }, 3000);
    }
  }, [correctAnswer]);

  useEffect(() => {
    shuffleArray(wordsArray);
    setShowMissing(true);
    setShowResult(false);
    if (selectedWord !== "") {
      handleCheckWord();
    }
  }, [selectedWord]);

  useEffect(() => {
    const storedLevel = localStorage.getItem("selectedLevel");
    const storedGameType = localStorage.getItem("selectedGameType");
    if (storedLevel) {
      setSelectedLevel(storedLevel);
    }
    if (storedGameType) {
      setSelectedGameType(storedGameType);
    }
  }, []);

  useEffect(() => {
    if (
      selectedGameType === "FreePlay" &&
      showMissing &&
      !showAnswer &&
      !answerDropped
    ) {
      // Clear any existing timer
      if (hideCharactersTimer) {
        clearInterval(hideCharactersTimer);
      }

      // Start new timer to hide characters
      const timer = setInterval(() => {
        setVisibleGroups((prevGroups) => {
          // If we're down to 2 groups, show answer and move to next word
          if (prevGroups.length <= 2) {
            setShowAnswer(true);
            clearInterval(timer);
            setCurrentHint1(currentWordObj.hint2);
            setWrongAnswersCount((prevCount) => prevCount + 1);
            setTimeout(() => {
              handleNextWord();
            }, 3000);
            return prevGroups;
          }

          // Find the correct letter (answer)
          const correctLetter = currentWordObj.answer_so.toUpperCase();
          // Keep the correct letter and remove one random wrong letter
          const wrongLetters = prevGroups.filter(
            (letter) => letter !== correctLetter
          );
          const randomIndex = Math.floor(Math.random() * wrongLetters.length);
          const letterToRemove = wrongLetters[randomIndex];

          // Return new array without the randomly selected wrong letter
          return prevGroups.filter((letter) => letter !== letterToRemove);
        });
      }, 3000);

      setHideCharactersTimer(timer);

      // Cleanup function
      return () => {
        if (timer) {
          clearInterval(timer);
        }
      };
    }
  }, [currentIndex, showMissing, showAnswer, answerDropped, selectedGameType]);

  useEffect(() => {
    setVisibleGroups(commonWordsGroups);
  }, [currentIndex]);

  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  const handleDragStart = (event, groupIndex) => {
    setDraggedItem(groupIndex);
  };

  const handleDragOver = (event, groupIndex) => {
    setDraggedItem(groupIndex);
    event.preventDefault();
  };

  const onDragOver = (ev) => {
    ev.preventDefault();
  };

  const onDrop = (ev, cat) => {
    handleRowClick(draggedItem);
  };
  const endGame = () => {
    navigate("/");
  };
  const handleCheckWord = () => {
    setShowMissing(false);
    if (selectedWord.toLowerCase() === currentWordObj.answer_so) {
      setShowResult(true);
      setCorrectAnswer(true);
      setCurrentDescription(currentWordObj.description);
    } else {
      setShowResult(true);
      setCorrectAnswer(false);
    }
  };
  const handleCorretWord = () => {
    setShowCoinAnimation(true);
    if (currentIndex + 1 < wordsArray.length) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    } else {
      setGameLastQuestion(true);
    }
    setShowResult(false);
    setCorrectAnswer(false);
    setSelectedWord("");
    setShowMissing(true);
    setCurrentDescription("");
    setCurrentHint1("");
    setCurrentHint2("");
    setAnswerDropped(false);
  };
  const handleNextWord = () => {
    setShowDefinition(false);
    setShowAnswer(false);
    if (currentIndex + 1 < wordsArray.length) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    } else {
      setGameLastQuestion(true);
    }
    setShowResult(false);
    setCorrectAnswer(false);
    setSelectedWord("");
    setShowMissing(true);
    setCurrentDescription("");
    setCurrentHint1("");
    setCurrentHint2("");
    setCurrentHint3("");
    setAnswerDropped(false);
    setShowHintModal(false);
    setShowWordModal(false);
  };

  const handleWordSelect = (word) => {
    setSelectedWord(word);
    setShowMissing(true);
    handleCheckWord();
  };
  const handleAnswer = () => {
    setShowResult(true);
  };
  const handleNoAnswer = () => {
    setShowMissing(false);
    setShowResult(true);
  };
  const handleYesAnswer = () => {};
  const showHint = () => {
    setShowHintModal(true);
    setCurrentHint1(currentWordObj.hint2);
    if (points > 25) {
      setPoints((prevPoints) => {
        const newPoints = prevPoints - 25;
        return newPoints;
      });
    } else {
      navigate("/");
    }
  };

  const findWordIndexOnce = () => {
    let foundIndex = -1;
    let foundAlphabetIndex = 0;
    let found = false;

    englishAlphabet.forEach((letter, letterIndex) => {
      if (letter === currentWordObj.answer_so) {
        found = true;
        foundIndex = letterIndex;
      }
    });

    if (found) {
      foundAlphabetIndex = foundIndex;
    }

    return foundAlphabetIndex;
  };

  const findWordIndex = (word) => {
    let foundIndex = -1;
    let foundAlphabetIndex = 0;
    let found = false;

    englishAlphabet.forEach((letter, letterIndex) => {
      if (letter === word) {
        found = true;
        foundIndex = letterIndex;
      }
    });

    if (found) {
      foundAlphabetIndex = foundIndex;
    }

    return foundAlphabetIndex;
  };

  const handleRowClick = (letter) => {
    if (currentWordObj.answer_so) {
      setShowMissing(false);
      if (letter.toLowerCase() == currentWordObj.answer_so) {
        handleScreenShot(true);
        setAnswerDropped(true);
        setPoints((prevPoints) => {
          const newPoints = prevPoints + 100;
          const emailSentVocap = localStorage.getItem("emailSentVocap");
          if (!emailSentVocap && newPoints > 2500 && prevPoints <= 2500) {
            setShowEmailModal(true);
            localStorage.setItem("emailSentVocap", true);
          }
          return newPoints;
        });
        if (selectedGameType === "TimedPlay") {
          setConsecutiveCorrect((prev) => {
            const newCount = prev + 1;
            if (newCount === 3) {
              setTimeLeft((time) => time + 5); // Add 5 seconds
              setShowSecondsAnimation(true); // Show the animation
              setTimeout(() => {
                setShowSecondsAnimation(false);
              }, 2000); // Hide after 1 second
              return 0; // Reset counter after reaching 3
            }
            return newCount;
          });
        }
        if (selectedGameType === "FreePlay") {
          setCorrectAnswersCount((prevCount) => prevCount + 1);
        }
        handleCorretWord();
        setTimeout(() => {
          setShowCoinAnimation(false);
        }, 3000);
      } else {
        handleScreenShot(false);
        setShowResult(true);
        setCorrectAnswer(false);
        setAnswerDropped(false);
        setCurrentHint1(currentWordObj.hint3);

        if (selectedGameType === "FreePlay") {
          // Only show answer and end the round if we're down to 1 or fewer groups
          if (visibleGroups.length <= 2) {
            setShowAnswer(true);
            setWrongAnswersCount((prevCount) => prevCount + 1);
            setTimeout(() => {
              handleNextWord();
            }, 3000);
          } else {
            // If we have more groups, just show the wrong answer feedback briefly
            setTimeout(() => {
              setShowResult(false);
              setShowMissing(true);
            }, 1000);
          }
        }
        // Reset consecutive correct counter on wrong answer

        if (selectedGameType === "TimedPlay") {
          if (points > 150) {
            setPoints(points - 150);
          } else {
            setShowNotEnoughCoinsModal(true);
            setTimeout(() => {
              navigate("/");
            }, 3000);
          }
          setConsecutiveCorrect(0);
          setTimeout(() => {
            handleNextWord();
          }, 1000);
        }
      }
    } else {
      console.log("No word selected.");
    }
    if (currentIndex + 1 === wordsArray.length) {
      console.log(currentIndex);
      console.log("last", gameLastQuestion);
    }
  };

  const handleEmailSubmit = async (e) => {
    if (codes.length === 0) {
      fetchData();
    }

    // Ensure codes is an array
    if (!Array.isArray(codes)) {
      console.error("Codes is not an array:", codes);
      return;
    }

    // Filter codes with status false
    const falseStatusCodes = codes.filter((item) => !item.status);

    if (falseStatusCodes.length === 0) {
      alert("No codes with false status are left.");
      return;
    }

    // Select a random code
    const randomItem =
      falseStatusCodes[Math.floor(Math.random() * falseStatusCodes.length)];
    setRandomCode(randomItem.code);

    // Update the status of the selected code
    const updatedCodes = codes.map((item) =>
      item.code === randomItem.code ? { ...item, status: true } : item
    );

    updateData(updatedCodes);

    e.preventDefault();
    const serviceID = "service_pof0q1i";
    const templateID = "template_b0o4idr";
    const userID = "gXsygUtSGNRXESn60";
    const templateParams = {
      to_email: email,
      message:
        "Your email address has been added to the GP Rewards Daily Raffle list for a chance to win our signature prize. Starting tomorrow, you can <a href='https://www.goodppls.com'>Click here</a> to see if you have been selected as the winner. There is a new winner every day.",
    };
    console.log("Sending email to:", email);
    setShowEmailModal(false);
    try {
      await emailjs.send(serviceID, templateID, templateParams, userID);
      console.log("Email successfully sent!");
      setShowEmailModal(false);
    } catch (error) {
      console.error("Failed to send email:", error);
    }
  };
  const checkWordGroup = (word, letter) => {
    return letter === word;
  };
  const handleWordClick = (word) => {
    setClickedWord(word);
  };

  const correctOptions = {
    loop: true,
    autoplay: true,
    animationData: correctAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

    const secondAddedOption = {
      loop: true,
      autoplay: true,
      animationData: secondAdded,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

  const coinAddedOption = {
    loop: true,
    autoplay: true,
    animationData: coinAdded,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const walletOption = {
    loop: true,
    autoplay: true,
    animationData: wallet,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const FullContainer = styled.div`
    overflow-y: scroll;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-width: 10px;
    border-style: solid;
    border-image-slice: 1;
    border-image-source: ${(props) =>
      props.success === null
        ? "linear-gradient(45deg, transparent, transparent)"
        : props.success
        ? "linear-gradient(45deg, #88d988, #65e365)"
        : "linear-gradient(45deg, #ef6565, #ef6565)"};
    padding: 20px;
    animation: ${(props) => (props.success !== null ? gradientShadow : "none")}
      1s infinite;
    transition: border-color 0.3s ease-in-out, opacity 0.3s ease-in-out;
  `;
  const gradientShadow = keyframes`
  0% {
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.7);
  }
  50% {
    box-shadow: 0 0 20px rgba(0, 255, 0, 0.9);
  }
  100% {
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.7);
  }
`;
  const [isSuccess, setIsSuccess] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const handleScreenShot = (success) => {
    setIsSuccess(success);
    setIsVisible(true);

    setTimeout(() => {
      setIsSuccess(null);
      setIsVisible(false);
    }, 500);
  };
  const fetchData = () => {
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          try {
            const response = JSON.parse(xhr.responseText);
            console.log(response);
            // Ensure response.record is an array
            setCodes(
              Array.isArray(response.record.record)
                ? response.record.record
                : []
            );
          } catch (e) {
            console.error("Error parsing JSON:", e);
            setCodes([]); // Clear codes on error
          }
        } else {
          console.error("Error fetching data:", xhr.status, xhr.statusText);
        }
      }
    };
    xhr.open("GET", `https://api.jsonbin.io/v3/b/${BIN_ID}`, true);
    xhr.setRequestHeader("X-Master-Key", API_KEY);
    xhr.send();
  };

  // Function to update data in JSONBin
  const updateData = (updatedCodes) => {
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          fetchData(); // Refresh data
        } else {
          console.error("Error updating data:", xhr.status, xhr.statusText);
        }
      }
    };
    xhr.open("PUT", `https://api.jsonbin.io/v3/b/${BIN_ID}`, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("X-Master-Key", API_KEY);
    xhr.send(JSON.stringify({ record: updatedCodes }));
  };


  const groupConsecutiveSubstrings = (substrings) => {
    const specialPairs = new Set(["ch", "ny", "dh", "ph", "zy", "sh", "ts"]);
    let grouped = [];
    let temp = [substrings[0]];

    for (let i = 1; i < substrings.length; i++) {
      const current = substrings[i];
      const previous = substrings[i - 1];

      // Check if the current and previous substrings form a special pair
      if (specialPairs.has(previous + current)) {
        temp.push(current);
      }
      // Check if current is the same as previous (for consecutive substrings)
      else if (current === previous) {
        temp.push(current);
      } else {
        grouped.push(temp);
        temp = [current];
      }
    }

    grouped.push(temp);
    return grouped;
  };
  const getColor = (group) => {
    const substring = group.join("");
    const isSpecialPair = ["ch", "ny", "dh", "ph", "zy", "sh", "ts"].includes(
      substring
    );
    const isDoubleLetter =
      group.length > 1 && group.every((char) => char === group[0]);

    if (isSpecialPair) return "#ffd800";
    if (isDoubleLetter) return "red";
    return "black";
  };

  // Inside your component
  const groupedSubstrings = groupConsecutiveSubstrings(currentWordObj.so);
  return (
    <>
      <FullContainer success={isSuccess} visible={isVisible}>
        <Container>
          <Row>
            {/* <Col xs={3} md={3} className="d-none d-md-block"></Col> */}
            <Col xs={12} md={7}>
              {!gameLastQuestion ? (
                <div class="row">
                  <div class="col">
                    <div className="word-container">
                      {selectedGameType === "TimedPlay" ? (
                        <div className="circle-timer">
      <h1 className="timer-text">{timeLeft}</h1>
    </div>
                      ) : (
                        <></>
                      )}

                      <div
                        className={`word-select mt-4 ${
                          showMissing ? "hidden" : ""
                        }`}
                      >
                        <div
                          className={`word ${
                            correctAnswer ? "correctAnimation" : ""
                          }`}
                        >
                          {groupedSubstrings.map((group, index) => (
                            <div
                              key={index}
                              className="substring-box"
                              style={{
                                // color: getColor(group),
                                cursor: "pointer",
                              }}
                              onClick={() => handleWordClick(group[0])}
                            >
                              {currentWordObj.hide ? (
                                <>
                                  {group.includes(currentWordObj.answer_so) &&
                                  index ===
                                    parseInt(currentWordObj.hide) - 1 ? (
                                    <button
                                      className="easy-btn droppable"
                                      onDragOver={(e) => onDragOver(e)}
                                      onDrop={(e) => onDrop(e)}
                                      style={{
                                        fontSize:
                                          answerDropped || showAnswer
                                            ? "35px"
                                            : "25px",
                                        color:
                                          columnColors[findWordIndexOnce()],
                                      }}
                                    >
                                      {answerDropped || showAnswer
                                        ? currentWordObj.answer_so
                                        : "?"}
                                    </button>
                                  ) : (
                                    group.join("") // Render consecutive substrings in the same box
                                  )}
                                </>
                              ) : (
                                <>
                                  {group.includes(currentWordObj.answer_so) ? (
                                    <button
                                      className="easy-btn droppable"
                                      onDragOver={(e) => onDragOver(e)}
                                      onDrop={(e) => onDrop(e)}
                                      style={{
                                        fontSize:
                                          answerDropped || showAnswer
                                            ? "35px"
                                            : "25px",
                                        color:
                                          columnColors[findWordIndexOnce()],
                                      }}
                                    >
                                      {answerDropped || showAnswer
                                        ? currentWordObj.answer_so
                                        : "?"}
                                    </button>
                                  ) : (
                                    group.join("") // Render consecutive substrings in the same box
                                  )}
                                </>
                              )}
                            </div>
                          ))}
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      {showResult && (
                        <div className="result-container make-center">
                          <p
                            className={`text-center result ${
                              correctAnswer ? "correct" : "incorrect"
                            }`}
                          >
                            <h2 style={{ marginLeft: "20px" }}>
                              {correctAnswer ? (
                                <Lottie
                                  options={correctOptions}
                                  height={100}
                                  width={300}
                                  isClickToPauseDisabled={true}
                                />
                              ) : (
                                <>
                                  {!showAnswer ? (
                                    <>
                                    </>
                                  ) : (
                                    <p className="hint make-center">
                                      <h5>Definition: {currentHint1}</h5>
                                    </p>
                                  )}
                                </>
                              )}

                              {/* {selectedLevel === "Beginner" ? (
                              <div>
                                  <button
                                    className="btn btn2 mb-4"
                                    onClick={handleNextWord}
                                  >
                                    Next Word
                                  </button>  ): ('')
                              }    */}
                            </h2>
                          </p>
                        </div>
                      )}
                      {showMissing &&
                        selectedLevel === "Beginner" &&
                        selectedGameType === "FreePlay" && (
                          <div className="">
                            {!showAnswer ? (
                              <button
                                class="btn me-2 mb-2"
                                style={{ marginLeft: "35px" }}
                                onClick={() => showHint()}
                              >
                                Hint
                              </button>
                            ) : null}
                            {!showAnswer && currentHint2 !== "" ? (
                              <p className="hint">
                                <h5>{currentHint2}</h5>
                              </p>
                            ) : null}
                            {showAnswer ? (
                              <p className="hint make-center">
                                <h5>Definition: {currentHint1}</h5>
                              </p>
                            ) : (
                              <></>
                            )}
                            {!showDefinition && !showAnswer ? (
                              <div
                                className="buttons-container"
                                style={{
                                  marginLeft: "35px",
                                  marginTop: "20px",
                                }}
                              >
                                {visibleGroups.map((letter) => {
                                  const foundIndex = findWordIndex(letter);
                                  const foundCharacter =
                                    englishAlphabet[foundIndex];

                                  return (
                                    <div
                                      key={letter}
                                      className=""
                                      draggable
                                      onDragStart={(e) =>
                                        handleDragStart(e, letter)
                                      }
                                      onDragOver={(e) => {
                                        e.preventDefault();
                                        handleDragOver(e, letter);
                                      }}
                                      onClick={() => handleRowClick(letter)}
                                    >
                                      <button className="btn-group mb-2 me-2">
                                        <span className="">
                                          {foundCharacter}
                                        </span>
                                      </button>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        )}
                      {showMissing &&
                        selectedLevel === "Beginner" &&
                        selectedGameType === "TimedPlay" && (
                          <div className="">
                            {!timeIsUp && showAnswer ? (
                              <p className="hint make-center">
                                <h5>Definition: {currentHint1}</h5>
                              </p>
                            ) : (
                              <></>
                            )}
                            {!timeIsUp && !showDefinition ? (
                              <div
                                className="buttons-container"
                                style={{
                                  marginLeft: "35px",
                                  marginTop: "20px",
                                }}
                              >
                                {visibleGroups.map((letter) => {
                                  const foundIndex = findWordIndex(letter);
                                  const foundCharacter =
                                    englishAlphabet[foundIndex];

                                  return (
                                    <div
                                      key={letter}
                                      className=""
                                      draggable
                                      onDragStart={(e) =>
                                        handleDragStart(e, letter)
                                      }
                                      onDragOver={(e) => {
                                        e.preventDefault();
                                        handleDragOver(e, letter);
                                      }}
                                      onClick={() => handleRowClick(letter)}
                                    >
                                      <button className="btn-group mb-2 me-2">
                                        <span className="">
                                          {foundCharacter}
                                        </span>
                                      </button>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <></>
                            )}

                            <div>
                              {currentIndex + 1 < wordsArray.length ? (
                                <></>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  {gameLastQuestion ? (
                    <>
                      <p>Game Over.</p>
                      {selectedGameType === "FreePlay" && (
                        <div className="report-container">
                          <h3>Game Report</h3>
                          <p>Correct Answers: {correctAnswersCount}</p>
                          <p>Wrong Answers: {wrongAnswersCount}</p>
                        </div>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              )}
            </Col>
            <Col xs={12} md={3}>
              <Row className="d-flex justify-content-center align-items-center">
                <button className="btn btn2 floating-button" onClick={endGame}>
                  End Game
                </button>
              </Row>
            </Col>

            <Modal
              show={showWordModal && !showAnswer}
              onHide={() => setShowWordModal(false)}
              className="small-modal"
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <h1 className="text-center">
                  {currentWordObj.so[currentWordObj.so.indexOf(clickedWord)]}
                </h1>
              </Modal.Body>
            </Modal>
            <Modal
              show={showHintModal && !showAnswer}
              onHide={() => setShowHintModal(false)}
              className="small-modal"
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <p className="hint make-center">
                  <h5>Definition: {currentHint1}</h5>
                </p>
              </Modal.Body>
            </Modal>
            <Modal
              // show={isDisabled}
              show={showGameOverModal}
              onHide={() => setShowGameOverModal(false)}
              className="small-modal"
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <p className="hint make-center">
                  <h5>You scored {points} points.</h5>
                </p>
                <p className="hint make-center">
                  <h5>Game Over</h5>
                </p>
              </Modal.Body>
            </Modal>
            <Modal
              show={showNotEnoughCoinsModal}
              onHide={() => setShowNotEnoughCoinsModal(false)}
              className="small-modal"
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <p className="hint make-center">
                  <h5>Practice more and try again.</h5>
                </p>
              </Modal.Body>
            </Modal>
          </Row>
        </Container>
      </FullContainer>
      <Modal show={showEmailModal} onHide={() => setShowEmailModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            Congratulations you have accumulated 2500 coins!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEmailSubmit}>
            <Form.Group controlId="formEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Type email address here to be entered into our raffle"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="btn btn2 mb-4">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      {selectedGameType === "TimedPlay" && showSecondsAnimation && (
              <div
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1000,
                }}
              >
                <Lottie
                  options={secondAddedOption}
                  height={100}
                  width={70}
                  isClickToPauseDisabled={true}
                />
              </div>
            )}
    </>
  );
}

export default GamePage;
